import { getFiltersFromURL, updateURLWithFilters } from '@/utils';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

export function useOrdersUrlSync({
  searchStore,
  filterStore,
  resetFilers,
}: {
  searchStore: any;
  filterStore: any;
  resetFilers: () => void;
}) {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const filters = getFiltersFromURL(searchParams);

    // Search
    if (filters.search || filters.searchBy) {
      searchStore.setSearchValue({
        search: filters.search,
        searchBy: filters.searchBy,
      });
    } else {
      searchStore.setSearchValue({ search: null, searchBy: null });
    }

    //Page
    if (filters.page) {
      filterStore.setCurrentPage?.(filters.page);
    }

    // Filters — same [Dayjs, Dayjs] shape the date picker writes (getOrderParams reads [0]/[1])
    const from = dayjs(filters.createdFrom);
    const to = dayjs(filters.createdTo);
    if (filters.createdFrom && filters.createdTo && from.isValid() && to.isValid()) {
      filterStore.setCreatedAt?.([from, to]);
    }
    if (filters.orderType) {
      filterStore.setOrderType?.(filters.orderType);
    }
  }, []);
  useEffect(() => {
    if (!location.pathname.startsWith('/orders')) return;

    const filtersToSync = {
      search: searchStore.searchValue?.search,
      searchBy: searchStore.searchValue?.searchBy,
      createdFrom: filterStore.createdAtFilter?.[0]?.format('YYYY-MM-DD'),
      createdTo: filterStore.createdAtFilter?.[1]?.format('YYYY-MM-DD'),
      orderType: filterStore.orderTypeFilter,
      page: filterStore.currentPage,
    };

    const isSearchChanged = !!filtersToSync.search || !!filtersToSync.searchBy;
    const isFilterChanged = !!filtersToSync.createdFrom || !!filtersToSync.orderType;

    updateURLWithFilters(setSearchParams, filtersToSync, {
      resetPage: isSearchChanged || isFilterChanged,
    });
  }, [
    location.pathname,
    searchStore.searchValue,
    filterStore.createdAtFilter,
    filterStore.orderTypeFilter,
    filterStore.currentPage,
  ]);

  useEffect(() => {
    return () => {
      if (!location.pathname.startsWith('/orders')) {
        searchStore.setSearchValue({ search: null, searchBy: null });
        resetFilers();
      }
    };
  }, [location.pathname]);
}
